import CombinedFab from './CombinedFAB';

export default CombinedFab